import React from 'react';

import { Button, Space } from 'antd';
import { useDispatch } from 'dva';

import EyeFilled from '@/assets/icons/eye_filled.svg';
import DownloadFileOutlined from '@/assets/icons/download_file_outlined.svg';
import styles from '../style.less';

const ImagePreview = ({ item, editGridMode }) => {
  const dispatch = useDispatch();

  const previewUrl = item.isBase64
    ? `data:${item.contentType};base64,${item.previewUrl ?? item.downloadUrl}`
    : item.previewUrl ?? item.downloadUrl;

  const downloadUrl = item.isBase64
    ? `data:${item.contentType};base64,${item.downloadUrl}`
    : item.downloadUrl;

  const handleDownload = () => {
    dispatch({
      type: 'global/directDownload',
      payload: { ...item, downloadUrl },
    });
  };

  const handlePreview = () => {
    const { fileName, contentType } = item;
    dispatch({
      type: 'global/filePreview',
      payload: {
        isBase64: item.isBase64,
        fileType: contentType,
        filePath: item.previewUrl ?? item.downloadUrl,
        filename: fileName,
      },
    });
  };

  return (
    <div className={styles.rowImagePreview} style={{ backgroundImage: `url(${previewUrl})` }}>
      {!editGridMode && (
        <div>
          <Space size={6}>
            <Button
              type="primary"
              size="small"
              icon={<img alt="icon" src={EyeFilled} />}
              onClick={handlePreview}
            />
            <Button
              type="primary"
              size="small"
              icon={<img alt="icon" src={DownloadFileOutlined} />}
              onClick={handleDownload}
            />
          </Space>
        </div>
      )}
    </div>
  );
};

export default ImagePreview;
